<template>
  <div class="row">
    <div class="col-12">
      <custom-callout
        :border-color="item.status.color"
        class="mb-3 custom-callout"
        :has-toggle="Boolean(item.instrument.description)"
        :opened="item.opened"
        @click:open="open"
      >
        <div class="row">
          <div class="col-5">
            <div class="color-secondary-6 font-14">
              Instrumento:
            </div>
            <div class="font-weight-normal color-black font-16">
              {{ item.instrument.name }}
            </div>
          </div>
          <div class="col">
            <div class="color-secondary-6 font-14">
              Estatus:
            </div>
            <div class="font-weight-normal color-black font-16">
              <custom-balloon
                :background-color="item.status.color"
                dot
                :text="item.status.name"
              />
            </div>
          </div>
          <div class="col">
            <div class="color-secondary-6 font-14">
              Fecha de Completado:
            </div>
            <div class="font-weight-normal color-black font-16">
              {{ item.completedDate | date }}
            </div>
          </div>
          <div class="col-2">
            <action-button
              :i="canComplete ? 'fas fa-check-circle' : 'fas fa-file-import'"
              :text="canComplete ? 'Completar' : 'Ver Instrumento'"
              variant="outline-success mr-3 px-3"
              @click="complete()"
            />
          </div>
        </div>
        <template v-if="item.instrument.description" #edition>
          <div class="p-2 custom-callout-edition">
            <div class="bg-white rounded p-3">
              <div class="label mb-2">
                <i class="fas fa-file text-orange" />
                Descripción
              </div>
              <span class="info">
                {{ item.instrument.description }}
              </span>
            </div>
          </div>
        </template>
      </custom-callout>
    </div>
  </div>
</template>

<script>
//components
import CustomCallout from 'custom-callout';
import CustomBalloon from 'custom-balloon';
import ActionButton from 'ActionButton';

//services

//constants
import InstrumentStatusTypes from '@/utils/constants/instrumentStatuses.js';

export default {
  name: 'VocationalEducationSixResultRow',
  components: {
    CustomCallout,
    CustomBalloon,
    ActionButton,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  computed: {
    canComplete() {
      return (
        this.item.status.id === InstrumentStatusTypes.Draft && !this.isReadOnly
      );
    },
  },
  methods: {
    open() {
      this.item.opened = !this.item.opened;
    },
    complete() {
      this.$router.push({
        name: 'InstrumentDetail',
        params: {
          id: this.item.id,
        },
      });
    },
  },
};
</script>
<style scoped></style>
